import { serialize } from './query-string'
import * as t from '../types'

export default function hasSelectedFilters(
  filterValues: t.FilterValues,
  category = '',
  baseFilterValues?: t.FilterValues
) {
  return serialize(filterValues, category, baseFilterValues).hasFilterValue
}
